<template>
  <div style="padding-left: 100px" id="details">
    <el-table
        :data="tableData"
        style="width: 100% ; padding-left: 10px"
        :default-sort="{prop: 'date', order: 'descending'}"
    >
      <el-table-column
          prop="usageTime"
          label="日期"
          sortable
          width="180">
      </el-table-column>
      <el-table-column
          prop="userUsage"
          label="使用量">
      </el-table-column>
    </el-table>

  </div>
</template>
<script>
import {info} from "@/api/orderUsageDetalis"


export default {
  data() {
    return {
      tableData: []
    };
  },

  created() {
    this.getDetails()
  },

  deactivated() {
    this.$destroy();
  },
  methods: {  //
    // 获取商品详细信息
    getDetails() {
      let orderDetails = localStorage.getItem("balance")
      info(orderDetails).then(res => {

        this.tableData = res.data

      })
    },
    formatter(row, column) {
      return row.address;
    }
  }
};
</script>
<style scoped lang="scss">

</style>